import React from 'react';
import { UploadedFile } from './ChatInput';

interface FileDisplayItemProps {
    file: UploadedFile;
    onRemove: (id: string) => void;
}

const FileDisplayItem: React.FC<FileDisplayItemProps> = ({ file, onRemove }) => {
    const formatFileSize = (size: number): string => {
        if (size < 1024) return `${size} B`;
        if (size < 1024 * 1024) return `${(size / 1024).toFixed(1)} KB`;
        return `${(size / (1024 * 1024)).toFixed(1)} MB`;
    };

    return (
        <div className="flex items-center bg-background-secondary border border-glass-border rounded-lg px-3 py-2 text-sm">
            <div className="flex items-center">
                <div className="bg-background-tertiary rounded-md p-2 mr-2">
                    {file.type.startsWith('image/') ? (
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                            <circle cx="8.5" cy="8.5" r="1.5" />
                            <polyline points="21 15 16 10 5 21" />
                        </svg>
                    ) : file.isText ? (
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                            <polyline points="14 2 14 8 20 8" />
                            <line x1="16" y1="13" x2="8" y2="13" />
                            <line x1="16" y1="17" x2="8" y2="17" />
                            <polyline points="10 9 9 9 8 9" />
                        </svg>
                    ) : (
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z" />
                            <polyline points="13 2 13 9 20 9" />
                        </svg>
                    )}
                </div>
                <div>
                    <div className="font-medium truncate max-w-[120px]" title={file.name}>{file.name}</div>
                    <div className="text-xs text-gray-400">{formatFileSize(file.size)}</div>
                </div>
            </div>
            <button
                onClick={() => onRemove(file.id)}
                className="ml-2 text-gray-400 hover:text-white"
                type="button"
                aria-label="Remove file"
            >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <line x1="18" y1="6" x2="6" y2="18" />
                    <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
            </button>
        </div>
    );
};

export default FileDisplayItem; 